module.exports = __webpack_public_path__ + "static/arabien-9f237c48ee124de5b249f0b96f49cf80.svg";